import { Route, Routes, Outlet } from "react-router-dom";
import PrivateRoute from "./PrivateRoute";
import NeighborhoodAccessRoute from "./NeighborhoodAccessRoute";
import LoginPage from "../pages/Login/LoginPage";
import HelpMain from "../pages/help/HelpMain";
import Questions from "../pages/help/Questions";
import Cookies from "../pages/CookiesPage";
import AccountPageSettings from "../pages/settings/AccountPage";
import PreferencesPage from "../pages/settings/PreferencesPage";
import ParentalControls from "../pages/settings/ParentalControls";
import ForgotPasswordPage from "../pages/ForgotPasswordPage";
import ChangePassword from "../pages/ChangePasswordPage";
import PasswordUpdated from "../pages/PasswordUpdatedPage";
import EnterOTP from "../pages/EnterOtpPage";
import HomePage from "../pages/HomePage";
import WatchVideo from "../pages/watch/WatchVideo";
import Users from "../components/search/Users";
import ViewPostById from "../pages/ViewPostPage";
import AccountPage from "../pages/AccountPage";
import Repost from "../pages/account/Repost";
import Saved from "../pages/account/Saved";
import SavedFolderData from "../pages/account/SavedFolderData";
import PrivateCreate from "../pages/account/PrivateCreate";
import PrivateEmpty from "../pages/account/private/PrivateEmpty";
import ResetPassword from "../components/account/privateTab/ResetPassword";
import SetPassword from "../pages/account/private/SetPassword";
import EnterOtpContainer from "../pages/account/private/EnterOtpContainer";
import Liked from "../pages/account/Liked";
import Group from "../pages/account/Group";
import ProfileEdit from "../pages/account/ProfileEdit";
import OtherUserAccount from "../pages/other-user/OtherUserAccount";
import LiveStreamPage from "../pages/LiveStreamPage";
import LiveStreamsList from "../components/live-stream/LiveStreamsList";
import ViewLiveStream from "../pages/ViewLiveStreamPage";
import TestStreamPage from "../pages/TestStreamPage";
import SearchResultPage from "../pages/SearchPage";
import HashTagPage from "../pages/HashtagPage";
import HashTagStore from "../pages/hashtag/HashTagStore";
import HashTagRecent from "../pages/hashtag/HashTagRecent";
import HashTagOtherUser from "../components/hashTag/HashTagOtherUser";
import HashTagPopular from "../pages/hashtag/HashTagPopular";
import HashTagTrending from "../pages/hashtag/HashTagTrending";
import CreatedGroupChatRoom from "../components/group/GroupChatRoom";
import CreatedGroupInvite from "../components/group/GroupInvite";
import CreatedGroupModerators from "../components/group/GroupModerators";
import CreatedGroupMembers from "../components/group/GroupMembers";
import CreatedGroupSetting from "../components/group/GroupSetting";
import CreatedGroupInfo from "../components/group/GroupInfo";
import CreatedInduvitualGroup from "../pages/GroupPage";
import ModeratorApplications from "../components/group/ModeratorApplications";
import GroupMail from "../components/group/GroupMail";
import GroupReport from "../components/group/GroupReport";
import CreatedGroupSearch from "../components/group/GroupSearch";
import CreatedGroupPost from "../components/group/GroupPost";
import GroupPostComments from "../pages/group/GroupPostComments";
import GroupPostReport from "../pages/group/GroupPostReport";
import SavedPosts from "../pages/group/SavedPosts";
import CreatedGroupRequest from "../components/group/GroupRequest";
import HiddenPosts from "../pages/group/HiddenPosts";
import GroupListView from "../pages/group/GroupListView";
import Upload from "../components/videopage/Upload";
import CreateVideos from "../components/videopage/CreateVideos";
import ShopPage from "../pages/shop/ShopPage";
import ShopDetails from "../pages/shop/ShopDetails";
import Category from "../pages/shop/Category";
import WishlistPage from "../pages/shop/WishlistPage";
import BasketPage from "../pages/shop/BasketPage";
import AddressPage from "../pages/shop/AddressPage";
import PaymentPage from "../pages/shop/PaymentPage";
import OrderPlacedPage from "../pages/shop/OrderPlacedPage";
import PaymentDetails from "../components/shoppage/PaymentDetails";
import Favorites from "../components/shoppage/Favorites";
import SellProduct from "../components/shoppage/SellProduct";
import OrderPage from "../pages/shop/OrderPage";
import OrderCancel from "../components/shoppage/OrderCancel";
import OrderDetailsPage from "../pages/shop/OdrderDetailsPage";
import NotificationsPage from "../pages/settings/NotificationsPage";
import Neighborhood from "../pages/NeighborhoodPage";
import PostCreate from "../pages/neighborhood/PostCreate";
import UpdatePinboard from "../pages/neighborhood/UpdatePinboard";
import NewsCreate from "../pages/neighborhood/NewsCreate";
import NewsDetails from "../pages/neighborhood/NewsDetails";
import PinboardDetails from "../pages/neighborhood/PinboardDetails";
import NeighborSaved from "../pages/neighborhood/NeighborSaved";
import YourNeighborPost from "../pages/neighborhood/YourNeighborPost";
import YourNeighbor from "../pages/neighborhood/YourNeighbor";
import NeighborLocation from "../pages/neighborhood/NeighborLocation";
import NeighborhoodGuidelines from "../pages/neighborhood/NeighborhoodGuidelines";
import RecommendedUser from "../pages/users/RecommendedUser";
import FollowSuggestion from "../pages/users/FollowSuggestion";
import FriendshipSuggestion from "../pages/users/FriendshipSuggestion";
import ContentBasedUser from "../pages/users/ContentBasedUser";
import SwitchAccount from "../pages/SwitchAccountPage";
import PrivateTab from "../components/account/tabs/PrivateTab";
import NeighborInvite from "../pages/neighborhood/NeighborInvite";
import Notification from "../pages/NotificationsPage";
import NotificationLikesPage from "../pages/NotificationLikesPage";
import PublicRoute from "./PublicRoute";
import DraftVideosDetails from "../components/videopage/DraftVideosDetails";
import UploadVideo from "../components/videopage/UploadVideo";

import Messages from "../pages/MessagesPage";
import MessageRequest from "../pages/message/MessageRequest";
import MessageGroupChatRoom from "../pages/message/MessageGroupChatRoom";
import MessageChatRoom from "../pages/message/MessageChatRoom";
import MessageCreateNew from "../pages/message/MessageCreateNew";
import UserPosts from "../pages/group/UserPosts";
import UpdateNews from "../pages/neighborhood/UpdateNews";
import MessageGroupInfo from "../pages/message/MessageGroupInfo";
import GroupBanned from "../pages/group/GroupBanned";
import BlockedUser from "../pages/users/BlockedUser";
import MutualFriends from "../pages/MutualFriendsPage";
import Reshared from "../pages/other-user/Reshared";
import YourActivity from "../pages/settings/YourActivity";
import AccountSettings from "../pages/account/AccountSettings";
import PrivacySafety from "../pages/account/PrivacySafety";
import DraftVideos from "../pages/account/DraftVideos";
import LikedVideos from "../pages/account/LikedVideos";
import Commented from "../pages/account/Commented";
import WatchHistory from "../pages/account/WatchHistory";
import RecentlyDeleted from "../pages/account/RecentlyDeleted";
import AccountHistory from "../pages/account/AccountHistory";
import AccountConnections from "../components/account/AccountConnections";
import OtherAccountConnections from "../pages/other-user/OtherAccountConnections";
import AccountPass from "../pages/settings/AccountPass";
import AccountEditPass from "../pages/settings/AccountEditPass";
import AccountSessionHistory from "../pages/settings/AccountSessionHistory";
import AccountProfileData from "../pages/settings/AccountProfileData";
import AccountDelete from "../pages/settings/AccountDelete";
import AccountDetails from "../pages/settings/AccountDetails";
import AccountEditDetails from "../pages/settings/AccountEditDetails";
import AccountEmail from "../pages/settings/AccountEmail";
import VerifyEmail from "../pages/settings/VerifyEmail";
import AccountPhoneNumber from "../pages/settings/AccountPhoneNumber";
import VerifyPhone from "../pages/settings/VerifyPhone";
import AccountDOB from "../pages/settings/AccountDOB";
import FilterKeywords from "../pages/settings/FilterKeywords";
import CreateGroup from "../components/group/GroupCreate";
import CreateAccountWith from "../pages/signup/CreateAccountWith";
import CreateAccountWithEmail from "../pages/signup/CreateAccountWithEmail";
import CreateAccountWithPhone from "../pages/signup/CreateAccountWithPhone";
import AppleCallback from "../pages/auth/AppleCallback";
import AppleAuthError from "../pages/auth/AppleAuthError";
import AboutUs from "../pages/web/AboutUs";
import WhyWeExist from "../pages/web/WhyWeExist";
import WhatMakesDifferent from "../pages/web/WhatMakesDifferent";
import SocialProof from "../pages/web/SocialProof";
import OurTeam from "../pages/web/OurTeam";
import InterestsRoute from "./InterestsRoute";
import ContactUs from "../pages/web/ContactUs";
import OurFeatures from "../pages/web/OurFeatures";
import UserIntrest from "../pages/signup/UserIntrest";
import ManageInterests from "../pages/settings/ManageInterests";
import DownloadMyVideos from "../pages/settings/DownloadMyVideos";
import ReportCenter from "../pages/users/ReportCenter";
import PrivacyPolicy from "../pages/web/PrivacyPolicy";
import TermsAndCondition from "../pages/web/TermsAndCondition";
import CommunityGuidelines from "../pages/web/CommunityGuidelines";
import HelpAndSupport from "../pages/web/HelpAndSupport";
import EarlyCommunity from "../pages/web/EarlyCommunity";
import GetEarlyAccess from "../pages/web/GetEarlyAccess";
import InviteMembers from "../components/group/InviteMembers";
import TrustAndSafety from "../pages/web/TrustAndSafety";

export default function MainRouter() {
    return (
        <Routes>
            {/* Test Pages (Development Only) */}
            {/* {process.env.NODE_ENV === 'development' && (
                <Route path="/test-stream" element={<TestStreamPage />} />
            )} */}

            {/* Legal Pages */}
            <Route path="/cookies" element={<Cookies />} />
            <Route path="/terms-of-use" element={<TermsAndCondition />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/community-guidelines" element={<CommunityGuidelines />} />
            <Route path="/contact-us" element={<ContactUs />} />
            <Route path="/trust-and-safety" element={<TrustAndSafety />} />
            <Route path="/support" element={<HelpAndSupport />} />
            <Route path="/our-features" element={<OurFeatures />} />
            <Route path="/about-us" element={<AboutUs />} />
            <Route path="/about-us/why-we-exist" element={<WhyWeExist />} />
            <Route path="/about-us/what-makes-us-different" element={<WhatMakesDifferent />} />
            <Route path="/about-us/early-community" element={<EarlyCommunity />} />
            <Route path="/about-us/our-team" element={<OurTeam />} />
            <Route path="/about-us/get-early-access" element={<GetEarlyAccess />} />
            <Route path="/about-us/social-proof" element={<SocialProof />} />

            {/* Help Pages */}
            <Route path="/help" element={<HelpMain />} />
            <Route path="/help/:id" element={<Questions />} />

            {/* Auth Pages */}
            <Route path="/" element={<HomePage />} />
            <Route path="/v/:videoId" element={<HomePage />} />

            <Route element={<InterestsRoute />}>
                <Route path="/user-intrest" element={<UserIntrest />} />
            </Route>

            {/* Apple OAuth routes — outside PublicRoute so logged-in users can also hit them */}
            <Route path="/auth/apple/callback" element={<AppleCallback />} />
            <Route path="/auth/apple/error" element={<AppleAuthError />} />

            <Route element={<PublicRoute />}>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/resetpassword" element={<ForgotPasswordPage />} />
                <Route path="/enterotp/:email" element={<EnterOTP />} />
                <Route path="/changepassword/:otp/:email" element={<ChangePassword />} />
                <Route path="/password-updated" element={<PasswordUpdated />} />
                <Route path="/create-account-with" element={<CreateAccountWith />} />
                <Route path="/create-account/email" element={<CreateAccountWithEmail />} />
                <Route path="/create-account/phone" element={<CreateAccountWithPhone />} />
            </Route>

            {/* Private Routes */}
            <Route element={<PrivateRoute />}>
                <Route element={<Outlet />}>
                    {/* Home Routes */}
                    <Route path="/users" element={<Users />} />
                    <Route path="/watch/:id" element={<WatchVideo />} />
                    <Route path="/watch-video/:id" element={<ViewPostById />} />
                    {/* <Route path="/home/:id" element={<HomePage />} /> */}

                    {/* Account Routes */}
                    <Route path="/account" element={<AccountPage />} />
                    <Route path="/account/saved" element={<Saved />} />
                    <Route path="/account/group" element={<Group />} />
                    <Route path="/account/liked" element={<Liked />} />
                    <Route path="/account/repost" element={<Repost />} />
                    <Route path="/account/drafts" element={<DraftVideos />} />
                    <Route path="/account/:id" element={<OtherUserAccount />} />
                    <Route path="/account/settings" element={<AccountSettings />} />
                    <Route path="/account/edit/profile" element={<ProfileEdit />} />
                    <Route path="/accounts/:type" element={<AccountConnections />} />
                    <Route path="/user/:type/:id" element={<OtherAccountConnections />} />
                    <Route path="/account/saved/folder/:id" element={<SavedFolderData />} />

                    {/* Private Videos Routes */}
                    <Route path="/private" element={<PrivateTab />} />
                    <Route path="/private/empty" element={<PrivateEmpty />} />
                    <Route path="/private/setPassword/:otp" element={<SetPassword />} />
                    <Route path="/private/enter-otp" element={<EnterOtpContainer />} />
                    <Route path="/private/resetpassword" element={<ResetPassword />} />
                    <Route path="/private/createpassword" element={<PrivateCreate />} />

                    {/* Messages Routes */}
                    <Route path="/message" element={<Messages />} />
                    <Route path="/message/:id" element={<MessageChatRoom />} />
                    <Route path="/message/request" element={<MessageRequest />} />
                    <Route path="/message/create" element={<MessageCreateNew />} />
                    <Route path="/message/group/:id" element={<MessageGroupChatRoom />} />
                    <Route path="/message/group-info/:id" element={<MessageGroupInfo />} />

                    {/* Search Routes */}
                    <Route path="/search" element={<SearchResultPage />} />

                    {/* Hashtag Routes */}
                    <Route path="/hashtag" element={<HashTagPage />} />
                    <Route path="/hashtag/store" element={<HashTagStore />} />
                    <Route path="/hashtag/recent" element={<HashTagRecent />} />
                    <Route path="/hashtag/popular" element={<HashTagPopular />} />
                    <Route path="/hashtag/trending" element={<HashTagTrending />} />
                    <Route path="/hashtag/otheruser" element={<HashTagOtherUser />} />

                    {/* Video Routes */}
                    <Route path="/uploadvideo" element={<Upload />} />
                    <Route path="/draft-videos" element={<DraftVideos />} />
                    <Route path="/create-videos" element={<CreateVideos />} />
                    <Route path="/draft/:id" element={<DraftVideosDetails />} />
                    {/* <Route path="/upload-video" element={<UploadVideo />} /> */}

                    {/* Group Routes */}
                    {/* <Route path="/group-mail" element={<GroupMail />} />
                    <Route path="/group/invite" element={<CreatedGroupInvite />} />
                    <Route path="/group/list-view" element={<GroupListView />} />
                    <Route path="/group/:groupId/saved/" element={<SavedPosts />} />
                    <Route path="/group-banned/:groupId" element={<GroupBanned />} />
                    <Route path="/group/:groupId/hidden/" element={<HiddenPosts />} />
                    <Route path="/group-reports/:groupId" element={<GroupReport />} />
                    <Route path="/group/:groupId/userpost/" element={<UserPosts />} />
                    <Route path="/group/info/:groupId" element={<CreatedGroupInfo />} />
                    <Route path="/group/post/:groupId" element={<CreatedGroupPost />} />
                    <Route path="/group/:groupId" element={<CreatedInduvitualGroup />} />
                    <Route path="/group/search/:groupId" element={<CreatedGroupSearch />} />
                    <Route path="/group/request/:groupId" element={<CreatedGroupRequest />} />
                    <Route path="/group/member/:groupId" element={<CreatedGroupMembers />} />
                    <Route path="/group/chatroom/:groupId" element={<CreatedGroupChatRoom />} />
                    <Route path="/group/moderators/:groupId" element={<CreatedGroupModerators />} />
                    <Route path="/group/:groupId/postreport/:postId" element={<GroupPostReport />} />
                    <Route path="/group/update/:groupId/post/:postId" element={<CreatedGroupPost />} />
                    <Route path="/created/group/:groupId/settings/" element={<CreatedGroupSetting />} />
                    <Route path="/group/:groupId/post/:postId/comment" element={<GroupPostComments />} />
                    <Route path="/group/:groupId/moderator-applications" element={<ModeratorApplications />} /> */}
                    {/* <Route path="/createdgroupupdates" element={<CreatedGroupUpdates />} /> */}
                    {/* <Route path="/group/:groupId/post/:postId" element={<GroupSinglePost />} /> */}

                    {/* Shop Routes */}
                    {/* <Route path="/shop" element={<ShopPage />} />
                    <Route path="/order" element={<OrderPage />} />
                    <Route path="/basket" element={<BasketPage />} />
                    <Route path="/shopcategory" element={<Category />} />
                    <Route path="/wishlist" element={<WishlistPage />} />
                    <Route path="/shopdetails" element={<ShopDetails />} />
                    <Route path="/shopaddress" element={<AddressPage />} />
                    <Route path="/shoppayment" element={<PaymentPage />} />
                    <Route path="/ordercancel" element={<OrderCancel />} />
                    <Route path="/shop/favorites" element={<Favorites />} />
                    <Route path="/orderdetails" element={<OrderDetailsPage />} />
                    <Route path="/shop/sell-products" element={<SellProduct />} />
                    <Route path="/shoporderplaced" element={<OrderPlacedPage />} />
                    <Route path="/shop/payment-details" element={<PaymentDetails />} /> */}

                    {/* Group Creation Routes */}
                    {/* <Route path="/createnewgroup" element={<CreateGroup />} />
                    <Route path="/createnewgroup/:groupId" element={<CreateGroup />} />
                    <Route path="/invitemember/:groupId" element={<InviteMembers />} /> */}

                    {/* Live Stream Routes */}
                    {/* <Route path="/livestreams" element={<LiveStreamsList />} />
                    <Route path="/create-livestream" element={<LiveStreamPage />} />
                    <Route path="/view-livestream/:streamId" element={<ViewLiveStream />} /> */}

                    {/* Notification Routes */}
                    <Route path="/notification" element={<Notification />} />
                    <Route path="/notification/likes" element={<NotificationLikesPage />} />

                    {/* Settings Routes */}
                    <Route path="/settings/account" element={<AccountPageSettings />} />
                    <Route path="/settings/account/details" element={<AccountDetails />} />
                    <Route path="/settings/account/edit-details" element={<AccountEditDetails />} />
                    <Route path="/settings/account/email" element={<AccountEmail />} />
                    <Route path="/settings/account/verify-email" element={<VerifyEmail />} />
                    <Route path="/settings/account/phone-number" element={<AccountPhoneNumber />} />
                    <Route path="/settings/account/verify-phone" element={<VerifyPhone />} />
                    <Route path="/settings/account/pass" element={<AccountPass />} />
                    <Route path="/settings/account/dob" element={<AccountDOB />} />
                    <Route path="/settings/account/edit-pass" element={<AccountEditPass />} />
                    <Route path="/settings/account/session-history" element={<AccountSessionHistory />} />
                    <Route path="/settings/account/profile-data" element={<AccountProfileData />} />
                    <Route path="/settings/account/delete" element={<AccountDelete />} />
                    <Route path="/settings/youractivity" element={<YourActivity />} />
                    <Route path="/settings/liked-videos" element={<LikedVideos />} />
                    <Route path="/settings/comments" element={<Commented />} />
                    <Route path="/settings/watch-history" element={<WatchHistory />} />
                    <Route path="/settings/recently-deleted" element={<RecentlyDeleted />} />
                    <Route path="/settings/account-history" element={<AccountHistory />} />
                    <Route path="/settings/blocked" element={<BlockedUser />} />
                    <Route path="/settings/privacy-safety" element={<PrivacySafety />} />
                    <Route path="/settings/preferences" element={<PreferencesPage />} />
                    <Route path="/settings/parental-controls" element={<ParentalControls />} />
                    <Route path="/settings/content-preferences/filter-keywords" element={<FilterKeywords />} />
                    <Route path="/settings/notifications" element={<NotificationsPage />} />

                    {/* Additional Settings Routes */}
                    <Route path="/settings/interests" element={<ManageInterests />} />
                    <Route path="/settings/manage-videos" element={<DownloadMyVideos />} />

                    {/* Neighborhood Routes */}
                    <Route element={<NeighborhoodAccessRoute />}>
                        <Route path="/neighborhood" element={<Neighborhood />} />
                        <Route path="/neighborhood/invite" element={<NeighborInvite />} />
                        <Route path="/neighborhood/location" element={<NeighborLocation />} />
                        <Route path="/neighborhood/guidelines" element={<NeighborhoodGuidelines />} />
                    </Route>
                    {/* <Route path="/neighborhood/saved" element={<NeighborSaved />} />
                    <Route path="/neighborhood/news/:id" element={<NewsDetails />} />
                    <Route path="/neighborhood/news/create" element={<NewsCreate />} />
                    <Route path="/neighborhood/pinboard/create" element={<PostCreate />} />
                    <Route path="/neighborhood/posted" element={<YourNeighborPost />} />
                    <Route path="/neighborhood/news/update/:id" element={<UpdateNews />} />
                    <Route path="/neighborhood/your-neighbor" element={<YourNeighbor />} />
                    <Route path="/neighborhood/pinboard/:id" element={<PinboardDetails />} />
                    <Route path="/neighborhood/pinboard/update/:id" element={<UpdatePinboard />} /> */}

                    {/* User Recommendation Routes */}
                    <Route path="/reshared/:userId" element={<Reshared />} />
                    <Route path="/report-center" element={<ReportCenter />} />
                    <Route path="/switch/account" element={<SwitchAccount />} />
                    <Route path="/user/recommended" element={<RecommendedUser />} />
                    <Route path="/user/suggestion" element={<FollowSuggestion />} />
                    <Route path="/mutual-friends/:userId" element={<MutualFriends />} />
                    <Route path="/user/suggestion/content-based" element={<ContentBasedUser />} />
                    <Route path="/user/suggestion/friendship" element={<FriendshipSuggestion />} />
                </Route>
            </Route>
            <Route path="*" element={<h1>PAGE NOT FOUND</h1>} />
        </Routes>
    );
}